import WorkflowPage from './Workflow.page';

export default WorkflowPage;
